// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2P4a6","buttons":"Footer_buttons__p2H4J"};